// TradingViewWidget.tsx
import React, {memo, useEffect, useRef} from "react";

const TradingViewWidget: React.FC = () => {
    const container = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!container.current) return;

        // Проверка — если уже есть скрипт, ничего не делаем
        if (container.current.querySelector("script")) {
            return;
        }

        const script = document.createElement("script");
        script.src =
            "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
        script.type = "text/javascript";
        script.async = true;
        script.innerHTML = `
      {
        "lineWidth": 3,
        "lineType": 2,
        "chartType": "line",
        "showVolume": true,
        "fontColor": "rgb(106, 109, 120)",
        "gridLineColor": "rgba(46, 46, 46, 0.06)",
        "volumeUpColor": "#ECECED",
        "volumeDownColor": "#ECECED",
        "backgroundColor": "#ffffff",
        "widgetFontColor": "#0F0F0F",
        "upColor": "#22ab94",
        "downColor": "#f7525f",
        "borderUpColor": "#22ab94",
        "borderDownColor": "#f7525f",
        "wickUpColor": "#22ab94",
        "wickDownColor": "#f7525f",
        "colorTheme": "light",
        "isTransparent": false,
        "locale": "en",
        "chartOnly": true,
        "scalePosition": "right",
        "scaleMode": "Normal",
        "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
        "valuesTracking": "1",
        "changeMode": "price-and-percent",
        "symbols": [
          [
            "NASDAQ:FRHC|60M"
          ]
        ],
        "dateRanges": [
          "60m|1W"
        ],
        "fontSize": "10",
        "headerFontSize": "medium",
        "autosize": true,
        "lineColor": "rgba(76, 175, 80, 1)",
        "width": "100%",
        "height": "100%",
        "noTimeScale": false,
        "hideDateRanges": false
      }`;

        container.current.appendChild(script);

        return () => {
            if (container.current) {
                container.current.innerHTML = "";
            }
        };
    }, []);

    return (
        <div className="tradingview-widget-container" ref={container}>
            <div className="tradingview-widget-container__widget"></div>
        </div>
    );
};

export default memo(TradingViewWidget);
